<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content" style="margin-top: 20px;">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <!-- Entity Information Table -->
          <table class="table table-bordered form-inline enityDetails custom-table" style="margin-bottom: 25px;">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span><strong>{{ item.key }}</strong></span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>

          <!-- Main Schedule L Form Table -->
          <table class="table table-bordered form-inline">
            <thead>
              <tr>
                <th colspan="4">{{modalTitle}}</th>
              </tr>
              <tr>
                <th colspan="2"></th>
                <th colspan="1" class="subHeader">
                  <span class="schd-ins">(a) Beginning of tax year</span>
                </th>
                <th colspan="1" class="subHeader">
                  <span class="schd-ins">(b) End of tax year</span>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (row of scheduleLFormView.rows; track $index; let i = $index) {
<tr>
                @if (row.num !== 'N/A') {
<td style="width: 58px">{{row.num}}</td>
}
                @if (row.num === 'N/A') {
<td colspan="4">{{row.description}}</td>
}
                @if (row.num !== 'N/A') {
<td>
                  {{row.description}}
                  <div style="float: right">
                    @if (row.description === 'Subtotals for assets') {
<button 
                            class="btn btn-info btn-sm" 
                            type="button" 
                            (click)="setDefault()">Set Default</button>
}
                  </div>
                </td>
}
                @if (row.num !== 'N/A') {
<td style="width: 110px" align="right">
                  <div>
                    <input class="form-control input-md numText"
                           type="text"
                           [ngModel]="row.value1"
                           (ngModelChange)="updateValue1(row, $event)"
                           [disabled]="row.num != 6 || row.num != 7">
                  </div>
                </td>
}
                @if (row.num !== 'N/A') {
<td style="width: 110px" align="right">
                  <div>
                    <input class="form-control input-md numText"
                           type="text"
                           [ngModel]="row.value2"
                           (ngModelChange)="updateValue2(row, $event)"
                           [disabled]="row.num != 6 || row.num != 7">
                  </div>
                </td>
}
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}

    <!-- Form View Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (showFormLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      @if (!showFormLoader) {
<div class="row L_SCHD_A">
        @if (scheduleLFormView.rows.length > 0) {
<table>
          <thead>
            <tr>
              <th colspan="4">
                <span class="schd-name">Schedule L</span>
                <span class="schd-desc">Part I-Total Assets</span>
                <span class="schd-ins">(see instructions)</span>
              </th>
            </tr>
            <tr>
              <th colspan="2" class="subDescriptionHeader">
                <span class='proration_span'>Part I:Total Assets (see instructions)</span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">
                  (a) Beginning of tax year
                </span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">
                  (b) End of tax year
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleLFormView.rows; track trackByIndex(i, row); let i = $index) {
<tr [style.display]="i === 0 ? 'none' : 'table-row'">
              <td>{{row.num}}</td>
              <td class="subDescriptionHeader">{{row.description}}</td>
              @if (i !== 6 && i !== 7) {
<td class="">
                <div class="input_enabled">{{row.value1}}</div>
              </td>
}
              @if (i !== 6 && i !== 7) {
<td class="">
                <div class="input_enabled">{{row.value2}}</div>
              </td>
}
            </tr>
}
          </tbody>
        </table>
}
      </div>
}
    </div>
}

    <!-- Audit Tab -->
    @if (activeTab === 3) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showRequestLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!showRequestLoader) {
<div class="main-header">
          <div class="col-sm-4">
            <span style="text-align: center; display: block;">Transaction Number</span>
          </div>
          <div class="col-sm-3">
            <span>User</span>
          </div>
          <div class="col-sm-2">
            <span>Date</span>
          </div>
          <div class="col-sm-3" style="padding-left: 20px">
            <span>View Transactions</span>
          </div>
        </div>
}
        @if (batchLoader) {
<div class="viewBatchLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!showRequestLoader && (!BatchList || BatchList.length === 0)) {
<div style="padding: 20px; text-align: center; color: #666;">
          No audit records available
        </div>
}
        @for (batchItem of BatchList; track $index; let batchIndex = $index) {
<div class="audit-container">
          <div class="audit-row">              
            <div class="col-sm-4">
              <span style="text-align: center; display: block;">{{batchItem.TRANSACTION_ID}}</span>
            </div>
            <div class="col-sm-3">
              <span>{{batchItem.USER_FIRST_NAME}} {{batchItem.USER_LAST_NAME}}</span>
            </div>
            <div class="col-sm-2">
              <span>{{batchItem.CREATED_ON}}</span>
            </div>
            <div class="col-sm-3">                   
              <button type="button" 
                      class="btn btn-primary view-trans-btn" 
                      (click)="showUploads(batchIndex, batchItem.TRANSACTION_ID)" 
                      [disabled]="batchItem.show_transaction">
                View Transactions
              </button> 
              <span>@if (batchItem.show_transaction) {
<i class="fa fa-spinner fa-spin gt-refresh"></i>
}</span>
            </div>
          </div>
          @if (batchItem.TOGGLE) {
<div class="transaction-details">
            @if (batchLoader) {
<div class="viewBatchLoader">
              <i class="fa fa-spinner fa-spin gt-refresh"></i>
            </div>
}
            @if (showBatchData && BatchListData && BatchListData.length > 0) {
<table class="table table-bordered form-inline">
              <thead>
                <tr style="background: #cd5763;color: white;font-weight: bold;">
                  <td style="width: 58px;padding: 0 20px;">#</td>
                  <td style="padding: 0 20px;">Description</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column A</td>
                  <td style="width: 110px;padding: 0;text-align: center;">Column B</td>
                </tr>
              </thead>
              <tbody>
                @for (batchData of BatchListData; track $index) {
<tr>
                  <td style="width: 58px;padding: 0 20px;">{{batchData.LINE_NO}}</td>
                  <td style="padding: 0 20px;">{{batchData.LINE_DESCRIPTION}}</td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{numberWithCommas(batchData.ATTRIBUTE_VALUE_A)}}
                    </div>
                  </td>
                  <td style="width: 110px;padding: 0;" align="right">
                    <div style="background: white;border-radius: 4px;margin: 2px;text-align: center;">
                      {{numberWithCommas(batchData.ATTRIBUTE_VALUE_B)}}
                    </div>
                  </td>
                </tr>
}
              </tbody>
            </table>
}
            <!-- Show message if no data -->
            @if (showBatchData && (!BatchListData || BatchListData.length === 0)) {
<div style="padding: 20px; text-align: center; color: #666;">
              No transaction data available
            </div>
}
          </div>
}
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
